module.exports = __webpack_public_path__ + "img/logo-white.5fd6acb.svg";